// Widgets offering the v2 engine toggle in their data settings. ButtonFilterWidget picks v2
// datasources in its own settings instead.
export const WIDGETS_WITH_DATASOURCE_V2 = ['CustomChartWidget', 'DataStripDatasetWidget', 'GaugeWidget', 'DonutWithTargetDatasetWidget', 'GridWidget'];

// Widgets loading their own rows page by page instead of through DatasourceV2Provider's query
export const WIDGETS_WITH_PAGED_DATA = ['GridWidget'];

export const parseDatasourceKey = (key) => {
  const match = String(key ?? '').match(/^v2-(\d+)$/);
  return match ? Number(match[1]) : null;
};

// A widget is never filtered by its own cross filters (button filter: button-filter-<id>,
// advanced filter: <id>-<button id>), otherwise e.g. a button filter would hide its other buttons.
export const isOwnCrossFilter = (filterId, widgetId) => (
  filterId === `button-filter-${widgetId}` || String(filterId).startsWith(`${widgetId}-`)
);

export const DATE_TRUNCS = ['year', 'quarter', 'month', 'week', 'day'];

// Aggregations the server supports (Datasource::Query::AGGREGATIONS); sum/avg need numbers
export const NUMERIC_AGG_FUNCS = ['sum', 'avg', 'min', 'max', 'count', 'count_distinct'];
export const OTHER_AGG_FUNCS = ['count', 'count_distinct', 'min', 'max'];

const NUMERIC_TYPES = ['integer', 'bigint', 'decimal', 'numeric', 'float', 'double', 'number', 'percentage', 'currency'];
const DATE_TYPES = ['date', 'datetime', 'timestamp'];
const BOOLEAN_TYPES = ['boolean', 'bool'];

export const isNumericColumn = (col) => NUMERIC_TYPES.includes(String(col?.data_type).toLowerCase());
export const isDateColumn = (col) => DATE_TYPES.includes(String(col?.data_type).toLowerCase());
export const isBooleanColumn = (col) => BOOLEAN_TYPES.includes(String(col?.data_type).toLowerCase());

// Cross filters are keyed by datasource id in the datasources slice; prefix v2 ids so they
// never collide with legacy datasource ids.
export const datasourceKey = (datasourceId) => (datasourceId == null ? null : `v2-${datasourceId}`);

export const queryKeyFor = (datasourceId, ...rest) => ['datasource_v2', datasourceId, ...rest];

export const schemaQueryKey = (dashboardId, datasourceId) => ['datasource_v2_schema', dashboardId, datasourceId];
